import React from 'react'
import { useTranslation } from 'react-i18next'
import { M_Fieldset } from 'src/M_Components'

export const Profile = ({ User }) => {
    const { t } = useTranslation()


    return (
        <div>
            <M_Fieldset
                labelInside
                label={t('Profile')}
                elements={
                    User &&
                    <>

                        <div style={{ display: 'flex', marginBottom: '30px' }}><b>{User?.User?.UserName}</b></div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'auto auto auto', gap: '20px', rowGap: '40px', marginBottom: '50px' }}>
                            <div><b>{t('Office')}:</b>{User?.Tenant}</div>
                            <div><b>{t("Email")}: </b>{User?.User?.Email}</div>
                            <div><b>{t("Phone")}: </b>{User?.User?.PhoneNumber}</div>
                            <div><b>{t("Roles")}: </b>{User?.Role.map(role => role.Name).toString().replaceAll(',', ', ')}</div>
                            <div><b>{t("Companies")}: </b>{User?.Companies.map(role => role.Code).toString().replaceAll(',', ', ')}</div>
                        </div>
                    </>
                }
            />
        </div>
    )
}
